import * as React from 'react';
import { PatternFormat } from 'react-number-format';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

function getTextFieldInputClasses(_a) {
    var className = _a.className, hasError = _a.hasError;
    return classNames("savvy-ui-p-4 savvy-ui-text-base savvy-ui-leading-4 savvy-ui-w-full savvy-ui-appearance-none savvy-ui-ring-1 savvy-ui-rounded savvy-ui-h-full focus:savvy-ui-outline-none placeholder:savvy-ui-text-gray-200", className, {
        "savvy-ui-ring-gray-200 focus-within:savvy-ui-ring-savvy": !hasError,
        "savvy-ui-ring-red": hasError,
    });
}
var labelClasses = "savvy-ui-text-xs savvy-ui-leading-3 savvy-ui-font-semibold savvy-ui-absolute -savvy-ui-top-3 savvy-ui-translate-y-1.5 savvy-ui-left-3 savvy-ui-px-1 savvy-ui-bg-white savvy-ui-z-10";

function TextFieldLabel(_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var labelClassNames = classNames(labelClasses, className);
    return typeof children === "string" ? (React.createElement("label", __assign({ className: labelClassNames, dangerouslySetInnerHTML: { __html: children } }, rest))) : (React.createElement("label", __assign({ className: labelClassNames }, rest), children));
}
function TextFieldContainer(_a) {
    var children = _a.children, label = _a.label, labelClassName = _a.labelClassName, className = _a.className, id = _a.id, errorMessage = _a.errorMessage, rest = __rest(_a, ["children", "label", "labelClassName", "className", "id", "errorMessage"]);
    return (React.createElement("div", __assign({ className: classNames("savvy-ui-group savvy-ui-relative savvy-ui-flex savvy-ui-flex-col savvy-ui-justify-center savvy-ui-rounded savvy-ui-bg-white", className) }, rest),
        label ? (React.createElement(TextFieldLabel, { htmlFor: id, className: classNames(labelClassName, {
                "savvy-ui-text-gray-100 group-focus-within:savvy-ui-text-savvy": !rest["aria-invalid"],
                "savvy-ui-text-red": rest["aria-invalid"],
            }) }, label)) : null,
        children,
        rest["aria-invalid"] && errorMessage ? (React.createElement("p", { className: "savvy-ui-mt-1 savvy-ui-text-xs savvy-ui-font-bold savvy-ui-text-red" }, errorMessage)) : null));
}

function TextFieldPrefix(props) {
    return (React.createElement("div", __assign({ className: "savvy-ui-pointer-events-none savvy-ui-absolute savvy-ui-top-0 savvy-ui-bottom-0 savvy-ui-flex savvy-ui-items-center savvy-ui-justify-center" }, props)));
}

var WrappedNumberFormatField = React.forwardRef(function NumberFormatField(_a, ref) {
    var className = _a.className, style = _a.style, label = _a.label, labelClassName = _a.labelClassName, errorMessage = _a.errorMessage, name = _a.name, id = _a.id, inputPrefix = _a.inputPrefix, _b = _a.prefixSpacing, prefixSpacing = _b === void 0 ? 32 : _b, rest = __rest(_a, ["className", "style", "label", "labelClassName", "errorMessage", "name", "id", "inputPrefix", "prefixSpacing"]);
    return (React.createElement(TextFieldContainer, { className: className, style: style, label: label, labelClassName: labelClassName, errorMessage: errorMessage, "aria-invalid": rest["aria-invalid"], id: id || name },
        React.createElement("div", { className: "savvy-ui-relative" },
            React.createElement(PatternFormat, __assign({ className: getTextFieldInputClasses({
                    hasError: Boolean(rest["aria-invalid"]),
                }), getInputRef: ref, name: name, id: id || name, style: __assign({}, (Boolean(inputPrefix) && { paddingLeft: prefixSpacing })) }, rest)),
            inputPrefix ? (React.createElement(TextFieldPrefix, { style: { width: prefixSpacing } }, inputPrefix)) : null)));
});

export { WrappedNumberFormatField as PatternFormatField };
//# sourceMappingURL=index.esm.js.map
